import { render, staticRenderFns } from "./ExtraInformation.vue?vue&type=template&id=81ca59bc"
import script from "./ExtraInformation.vue?vue&type=script&lang=js"
export * from "./ExtraInformation.vue?vue&type=script&lang=js"
import style0 from "./ExtraInformation.vue?vue&type=style&index=0&id=81ca59bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports